import videojs from 'video.js';

export type VideoJsPlayer = ReturnType<typeof videojs>;

export interface EtvPlayer extends VideoJsPlayer {
  playlist?: any; // TODO: add playlist types
  ima?: any; // TODO: add ima types
  ads?: any; // TODO: add ads types
}

export interface ILocation {
  city: { [key: string]: string };
  cityId: number;
  continent: { [key: string]: string };
  continentId: number;
  coordinates: { lat: number; lng: number };
  country: { [key: string]: string };
  countryId: number;
  elevation: number;
  state: { [key: string]: string };
  stateId: number;
  timeZone: string;
}

export interface PlaylistSource {
  src: string;
  type: string;
  bitrate: number;
  hight: number;
  label: string;
  selected: boolean;
}

export interface PlaylistItem {
  sources: PlaylistSource[];
  poster: string;
  location: ILocation;
  source: {
    id: string;
    alias: string;
  };
  time: Date;
  playlistItemId_: number;
}

interface PlayerConfig {
  live: boolean;
  playlist?: PlaylistItem[];
  clipMaxDuration?: number;
  parentHost: string;
  parentFullUrl: string;
  sourceId: string;
  publisherId: string;
  token: string;
  accountId: string;
  advertisement: {
    enabled: boolean;
    midroll: number;
    adserver: string;
  };
  adTargetTag?: string;
  stream?: string;
  mute: boolean;
  autoplay: boolean;
  language: string;
  stopLiveStreamInSec?: number;
  previewImage: string;
  location?: ILocation;
  logo?: string;
  maintenance?: boolean;
  ratio?: string;
  overlay: boolean;
}

export interface Clip {
  variants: [{ id: string; sourceVariantId: string; videoHeight: number; videoBitrate: number; urls: { cdn: string }; contentType: string }];
  medium: {
    sourceVariantId: string;
    mediaUrls: {
      previewImage: {
        cdn: string;
      };
    };
    startTime: string;
  };
  source: {
    alias: string;
    id: string;
    location: ILocation;
  };
}

interface EtvConfig {
  egress?: any;
  publisher?: any;
  playlist: {
    id: string;
    accountId: string;
    query: string;
    name: { [key: string]: string };
    updateTime: string;
  };
  clipMaxDuration: number;
  source: {
    accountId: string;
    alias: string;
    createTime: string;
    description: { [key: string]: string };
    id: string;
    listingStatus: string;
    location?: ILocation;
    maintenance: boolean;
    region: string;
    title: { [key: string]: string };
    updateTime: string;
    userData: { locationId: string };
    visibility: string;
  };
  stream: any;
  streamUris: {
    hls: string;
  };
  target: any;
  template: {
    language: AvailableLanguages;
    advertisement: {
      preroll: {
        enabled: boolean;
      };
      midroll: {
        enabled: boolean;
        interval: number;
      };
      postroll: {
        enabled: boolean;
      };
      powerlink: {
        enabled: boolean;
      };
      adserver: string;
    };
    accountId: string;
    analytics: any;
    assets: {
      logo: {
        id: string;
        urls: {
          cdn: string;
          edge: string;
        };
      };
      css: {
        id: string;
        urls: {
          cdn: string;
          edge: string;
        };
      };
    };
    createTime: any;
    id: string;
    name: string;
    playback: {
      autoplay: boolean;
      mute: boolean;
      limit: number;
    };
    overlay: {
      enabled: boolean;
    };
    updateTime: string;
  };
}

enum AvailableLanguages {
  ar = 'ar',
  cn = 'cn',
  de = 'dw',
  en = 'en',
  es = 'es',
  fa = 'fa',
  fr = 'fr',
  ku = 'ku',
  ru = 'ru',
  tr = 'tr',
  uk = 'uk',
  vi = 'vi',
  zh = 'zh',
}

export { PlayerConfig, AvailableLanguages, EtvConfig };
